require('../position/position.css');
module.exports = require('./index-nocss.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/ui-bootstrap4/src/modal/index.js
// module id = 438
// module chunks = 0